<template>
    <hts-modal
        :show="visible"
        :title="'Hủy booking ' + (bookingData.bookingNumber || '')"
        type="confirm"
        @hide="close"
        @confirm="handleCancel">
        <div class="p-4">
            <p class="text-gray-700 mb-4">
                Bạn có chắc chắn muốn hủy booking
                <span class="font-semibold">
                    {{ bookingData.bookingNumber }}
                </span>?
            </p>

            <div class="mb-4">
                <hts-form-select
                    v-model="reason"
                    v-model:text="reasonLabel"
                    :items="cancelReasons"
                    label="Lý do hủy"
                    placeholder="Chọn lý do hủy"
                    required />
            </div>

            <div v-if="reason === 'other'">
                <hts-form-textarea
                    v-model="reasonOther"
                    label="Lý do khác"
                    placeholder="Vui lòng nhập lý do hủy booking"
                    required />
            </div>
        </div>
    </hts-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const visible = ref(false)
const bookingData = ref<any>({})
const reason = ref('')
const reasonLabel = ref('')
const reasonOther = ref('')
const isSubmitting = ref(false)

const cancelReasons = [
  { label: 'Thay đổi kế hoạch vận chuyển', value: 'change_plan' },
  { label: 'Đã tìm được nhà vận chuyển khác', value: 'found_other_carrier' },
  { label: 'Giá cả không phù hợp', value: 'price_issue' },
  { label: 'Thời gian không phù hợp', value: 'time_issue' },
  { label: 'Lý do khác', value: 'other' }
]

const open = (data: any) => {
  bookingData.value = data
  reason.value = ''
  reason.value = ''
  reasonOther.value = ''
  visible.value = true
}

const close = () => {
  visible.value = false
}

const handleCancel = async () => {
  if (!reason.value) {
    process.client && $toast().error('Vui lòng chọn lý do hủy booking')
    return
  }

  if (reason.value === 'other' && !reasonOther.value) {
    process.client && $toast().error('Vui lòng nhập lý do hủy booking')
    return
  }

  isSubmitting.value = true

  try {
    const reasonText = reason.value === 'other' ? reasonOther.value : reasonLabel.value

    // API để hủy booking
    const response = await $api('/user/booking/cancel', {
      method: 'post',
      body: {
        id: bookingData.value._id,
        reasonCancel: reason.value,
        reasonCancelLabel: reasonText
      }
    })

    const resData = response?.data?.value

    if (resData?.success) {
      process.client && $toast().success('Hủy booking thành công')
      close()
      emits('refresh')
    } else {
      process.client && $toast().error(resData?.message || 'Hủy booking thất bại')
    }
  } catch (error) {
    console.error('Error cancelling booking:', error)
    process.client && $toast().error('Đã xảy ra lỗi khi hủy booking')
  } finally {
    isSubmitting.value = false
  }
}

const emits = defineEmits(['refresh'])

defineExpose({
  open,
  close
})
</script>
